<template>
  <div class="main-user">
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          label="必填信息"
          name="baseInfo"
          style="padding-bottom: 60px;"
        >
          <el-card>
            <div slot="header" class="clearfix">
              <span>基本信息</span>
            </div>
            <el-row>
              <el-form
                :model="userInfo"
                label-position="right"
                :rules="userRules"
                inline
                class="demo-ruleForm"
                label-width="100px"
                ref="userInfo"
              >
                <el-col :span="24">
                  <el-form-item label="证件照:" prop="idPhoto">
                    <image-uploader
                      :key="version"
                      ref="imageUploader"
                      @uploadCallback="submitUserInfo"
                      :file-name="userInfo.idNumber"
                      v-model="userInfo.idPhoto"
                      :upload-dir="userInfo.userId"
                      :width="100"
                      :height="140"
                    ></image-uploader>
                    <div style="color:red;">
                      建议图片尺寸为626*413像素
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="姓名:" prop="realName">
                    <el-input
                      v-model="userInfo.realName"
                      placeholder="姓名"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="性别:" prop="sex">
                    <el-select
                      v-model="userInfo.sex"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.sex"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="出生日期:" prop="birthday">
                    <el-date-picker
                      v-model="userInfo.birthday"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      editable
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="电子邮箱:" prop="email">
                    <el-input
                      v-model="userInfo.email"
                      placeholder="电子邮箱"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证件类型:" prop="idType">
                    <el-select
                      v-model="userInfo.idType"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.idType"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证件号码:" prop="idNumber">
                    <el-input
                      v-model="userInfo.idNumber"
                      placeholder="证件号码"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="民族:" prop="nationality">
                    <el-select
                      v-model="userInfo.nationality"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.nationality"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="政治面貌:" prop="politicalStatus">
                    <el-select
                      v-model="userInfo.politicalStatus"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.politicalStatus"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="婚姻状况:" prop="maritalStatus">
                    <el-select
                      v-model="userInfo.maritalStatus"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.maritalStatus"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="居住地:" prop="residence">
                    <el-cascader
                      v-model="userInfo.residence"
                      :options="areaOptions"
                      @active-item-change="handleItemChange"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="户籍地:" prop="censusRegister">
                    <el-cascader
                      v-model="userInfo.censusRegister"
                      :options="areaOptions"
                      @active-item-change="handleItemChange"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="毕业学校:" prop="graduateSchool">
                    <el-input
                      v-model="userInfo.graduateSchool"
                      placeholder="毕业学校"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="所学专业:" prop="major">
                    <el-input
                      v-model="userInfo.major"
                      placeholder="所学专业"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="学历:" prop="education">
                    <el-select
                      v-model="userInfo.education"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.education"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="学位:" prop="degree">
                    <el-select
                      v-model="userInfo.degree"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.degree"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系电话:" prop="mphone">
                    <el-input
                      v-model="userInfo.mphone"
                      placeholder="联系电话"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>通讯相关</span>
            </div>
            <el-form inline labelPosition="right" label-width="100px">
              <el-row>
                <el-col>
                  <el-form-item label="通讯地址:">
                    <el-input
                      v-model="userInfo.address"
                      placeholder="通讯地址"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="邮政编码:">
                    <el-input
                      v-model="userInfo.postcode"
                      placeholder="邮政编码"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>职业相关</span>
            </div>
            <el-form inline labelPosition="right" label-width="100px">
              <el-row>
                <el-col>
                  <el-form-item label="现从事职业:">
                    <el-input
                      v-model="userInfo.occupation"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="现职业类别:">
                    <el-select
                      v-model="userInfo.positionCategory"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.industryType"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="目前年薪:">
                    <el-select
                      v-model="userInfo.yearlySalary"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.yearlySalary"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>语言</span>
            </div>
            <el-form inline labelPosition="right" label-width="100px">
              <el-row>
                <el-col>
                  <el-form-item label="语言类型:">
                    <el-select
                      v-model="userInfo.languages"
                      placeholder="请选择"
                      clearable
                      multiple
                    >
                      <el-option
                        v-for="item in metaData.languages"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="语言水平:">
                    <el-select
                      v-model="userInfo.languageProficiency"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.languageProficiency"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="语言级别:">
                    <el-input
                      v-model="userInfo.languageLevel"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>计算机</span>
            </div>
            <el-form inline labelPosition="right" label-width="100px">
              <el-row>
                <el-col>
                  <el-form-item label="计算机水平:">
                    <el-select
                      v-model="userInfo.computerSkills"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.computerSkills"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="计算机等级:">
                    <el-select
                      v-model="userInfo.computerGrade"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.computerGrade"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="计算机级别:">
                    <el-select
                      v-model="userInfo.computerLevel"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.computerLevel"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="掌握语言:">
                    <el-input
                      v-model="userInfo.computerLanguages"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>其他</span>
            </div>
            <el-form inline labelPosition="right" label-width="100px">
              <el-row>
                <el-col>
                  <el-form-item label="海外经历:">
                    <el-select
                      v-model="userInfo.overseasExperience"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in metaData.overseasExperience"
                        :key="item.metaCode"
                        :label="item.metaName"
                        :value="item.metaCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="特长:">
                    <el-input
                      type="textarea"
                      v-model="userInfo.speciality"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="自我评价:">
                    <el-input
                      type="textarea"
                      v-model="userInfo.selfAssessment"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-col :span="24" class="bottom_bth">
            <el-button size="small" @click="onSubmitUserInfo">保存</el-button>
            <el-button size="small" @click="cancelResume">重置</el-button>
          </el-col>
        </el-tab-pane>

        <el-tab-pane name="communication" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>教育信息</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>教育经历</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddEdu"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="job" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>实习经历</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>实习经历</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddInternship"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="language" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>工作经历</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>工作经历</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddWork"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="computer" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>职业业绩</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>项目经历</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddProject"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="training" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>培训信息</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>培训信息</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddTraining"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="certificate" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>证书获得</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>所获证书</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddCertificate"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="honour" :disabled="!userInfo.userId">
          <span slot="label"
            ><el-tooltip
              :disabled="!!userInfo.userId"
              class="item"
              effect="dark"
              content="请先保存必填信息"
              placement="top"
            >
              <span>荣誉表彰</span>
            </el-tooltip></span
          >
          <el-card>
            <div slot="header" class="clearfix">
              <span>荣誉表彰</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="onAddHonour"
                >添加</el-button
              >
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
import {
  addResumeCertificate,
  addResumeEducation,
  addResumeHonour,
  addResumeInternship,
  addResumeProject,
  addResumeTraining,
  addResumeWork,
  addUser,
  deleteResumeCertificate,
  deleteResumeEducation,
  deleteResumeHonour,
  deleteResumeInternship,
  deleteResumeProject,
  deleteResumeTraining,
  deleteResumeWork,
  findResumeCertificate,
  findResumeEducation,
  findResumeHonour,
  findResumeInternship,
  findResumeProject,
  findResumeTraining,
  findResumeWork,
  getAllMapListMetaData,
  getResumeCertificateList,
  getResumeEducationList,
  getResumeHonourList,
  getResumeInternshipList,
  getResumeProjectList,
  getResumeTrainingList,
  getResumeWorkList,
  updateResumeCertificate,
  updateResumeEducation,
  updateResumeHonour,
  updateResumeInternship,
  updateResumeProject,
  updateResumeTraining,
  updateResumeWork
} from "@/api/userInfo";
import permission from "@/directive/permission"; // 权限判断指令
import {
  getAllProvince,
  getCityByAreaCode,
  getCityByProvince
} from "@/api/cityCode";
import ImageUploader from "@/components/imageUploader";

export default {
  name: "userInfoEdit",
  components: {
    ImageUploader
  },
  directives: { permission },
  inject: ["reload"],
  data() {
    return {
      version: new Date().getTime(),
      userId: null,
      mphoneFlag: null,
      userInfo: {
        userId: null,
        realName: null,
        sex: null,
        birthday: null,
        email: null,
        idType: null,
        idNumber: null,
        idPhoto: null,
        nationality: null,
        politicalStatus: null,
        maritalStatus: null,
        residence: null,
        censusRegister: null,
        graduateSchool: null,
        major: null,
        education: null,
        degree: null,
        mphone: null,
        address: null,
        postcode: null,
        occupation: null,
        positionCategory: null,
        yearlySalary: null,
        languages: null,
        languageProficiency: null,
        languageLevel: null,
        computerSkills: null,
        computerGrade: null,
        computerLevel: null,
        computerLanguages: null,
        overseasExperience: null,
        speciality: null,
        selfAssessment: null,
        vip: null,
        registerFrom: null
      },
      activeName: "baseInfo",
      registerDate: ["", ""],
      userFromOptions: [
        { label: "自行注册", value: "1" },
        { label: "代理商", value: "2" }
      ],
      auditStatusOptions: [
        { label: "已通过", value: "1" },
        { label: "未通过", value: "2" },
        { label: "未审核", value: "3" }
      ],
      areaOptions: [],
      loading: false,
      importPhoneVisible: false,
      isUserEdit: false,
      loadingInstance: null,
      serviceCount: 0,
      resumeEduInfoList: [],
      eduEditVisible: false,
      internshipEditVisible: false,
      projectEditVisible: false,
      trainingEditVisible: false,
      workEditVisible: false,
      certificateEditVisible: false,
      honourEditVisible: false,
      eduForm: {
        school: "",
        major: "",
        education: "",
        endTime: "",
        uploadEducationAnnex: []
      },
      internshipForm: {
        companyName: "",
        position: "",
        startTime: "",
        endTime: "",
        workContent: ""
      },
      projectForm: {
        projectName: "",
        startTime: "",
        endTime: "",
        projectDuty: "",
        projectResult: ""
      },
      trainingForm: {
        trainingCompany: "",
        srartTime: "",
        endTime: "",
        trainingContent: "",
        achievements: "",
        uploadCertificate: []
      },
      workForm: {
        companyName: "",
        position: "",
        startTime: "",
        endTime: "",
        workContent: ""
      },
      certificateForm: {
        certificateName: "",
        issuedBy: "",
        winningTime: "",
        uploadCertificate: []
      },
      honourForm: {
        certificateName: "",
        issuedBy: "",
        winningTime: "",
        uploadCertificate: []
      },
      userRules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        censusRegister: [
          { required: true, message: "请选择户籍地", trigger: "change" }
        ],
        idType: [
          { required: true, message: "请选择证件类型", trigger: "blur" }
        ],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" }
        ],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" }
        ],
        email: [{ required: true, message: "请输入电子邮箱", trigger: "blur" }],
        mphone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[34578]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur,change"
          }
        ]
      },
      eduRules: {
        school: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ],
        major: [{ required: true, message: "请输入专业名称", trigger: "blur" }],
        education: [{ required: true, message: "请选择学历", trigger: "blur" }],
        endTime: [
          { required: true, message: "请选择毕业年份", trigger: "blur" }
        ]
      },
      internshipRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间 ", trigger: "blur" }
        ]
      },
      projectRules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ]
      },
      trainingRules: {
        trainingCompany: [
          { required: true, message: "请输入培训机构名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ]
      },
      workRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间 ", trigger: "blur" }
        ]
      },
      certificateRules: {
        certificateName: [
          { required: true, message: "请输入证书名称", trigger: "blur" }
        ],
        issuedBy: [
          { required: true, message: "请输入发证单位名称", trigger: "blur" }
        ]
      },
      honourRules: {
        certificateName: [
          { required: true, message: "请输入荣誉表彰名称", trigger: "blur" }
        ],
        issuedBy: [{ required: true, message: "请输入描述", trigger: "blur" }],
        winningTime: [
          { required: true, message: "请选择时间", trigger: "change" }
        ]
      },
      saveEduBth: false,
      saveInternshipBth: false,
      saveProjectBth: false,
      saveTrainingBth: false,
      saveWorkBth: false,
      saveCertificateBth: false,
      saveHonourBth: false,
      resumeInternshipInfoList: [],
      resumeProjectInfoList: [],
      resumeTrainingInfoList: [],
      resumeWorkInfoList: [],
      resumeCertificateInfoList: [],
      resumeHonourInfoList: [],
      eduFileVisible: false,
      trainingFileVisible: false,
      certificateFileVisible: false,
      honourFileVisible: false,
      metaData: {},
      agentList: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initUser();
      this.getAllMapListMetaData();
      this.getAllProvince();
    },
    initUser() {
      this.userInfo = {
        userId: null,
        realName: null,
        sex: null,
        birthday: null,
        email: null,
        idType: null,
        idNumber: null,
        idPhoto: null,
        nationality: null,
        politicalStatus: null,
        maritalStatus: null,
        residence: null,
        censusRegister: null,
        graduateSchool: null,
        major: null,
        education: null,
        degree: null,
        mphone: null,
        address: null,
        postcode: null,
        occupation: null,
        positionCategory: null,
        yearlySalary: null,
        languages: null,
        languageProficiency: null,
        languageLevel: null,
        computerSkills: null,
        computerGrade: null,
        computerLevel: null,
        computerLanguages: null,
        overseasExperience: null,
        speciality: null,
        selfAssessment: null,
        vip: null,
        registerFrom: null
      };
      this.version = new Date().getTime();
    },
    getAllMapListMetaData() {
      getAllMapListMetaData().then(res => {
        if (res && res.code === "200") {
          this.metaData = res.data;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formatYear(d) {
      let date = new Date(d);
      return date.getFullYear();
    },
    formatDate(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return [year, month, day].map(this.formatNumber).join("-") + " 00:00:00";
    },
    formatMonth(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return [year, month].map(this.formatNumber).join("-");
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    handleClick(val) {
      if (this.userId) {
        switch (val.index) {
          case "0":
            this.onFindUserInfo();
            break;
          case "1":
            this.onGetResumeEducationList();
            break;
          case "2":
            this.onGetResumeInternshipList();
            break;
          case "3":
            this.onGetResumeWorkList();
            break;
          case "4":
            this.onGetResumeProjectList();
            break;
          case "5":
            this.onGetResumeTrainingList();
            break;
          case "6":
            this.onGetResumeCertificateList();
            break;
          case "7":
            this.onGetResumeHonourList();
            break;
        }
      }
    },
    onSubmitUserInfo() {
      let that = this;
      that.$refs["userInfo"].validate(valid => {
        if (valid) {
          if (
            that.userInfo.idPhoto &&
            that.userInfo.idPhoto.indexOf("data:") !== -1
          ) {
            that.$refs["imageUploader"].submit();
          } else {
            that.submitUserInfo();
          }
        } else {
          return false;
        }
      });
    },
    submitUserInfo() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      let data = that._.cloneDeep(that.userInfo);
      if (data.residence instanceof Array) {
        data.residence = data.residence
          .slice(data.residence.length - 1, data.residence.length)
          .toString();
      }
      if (data.censusRegister instanceof Array) {
        data.censusRegister = data.censusRegister
          .slice(data.censusRegister.length - 1, data.censusRegister.length)
          .toString();
      }
      if (data.languages instanceof Array) {
        data.languages = JSON.stringify(data.languages);
      }
      addUser(data).then(res => {
        that.loadingInstance.close();
        if (res && res.code === "200") {
          that.$message.success("保存成功");
          that.jumpPage({
            path: "/userInfo/editUser",
            query: { id: res.data.userId }
          });
        }
      });
    },
    jumpPage(router) {
      this.$router.push(router);
    },
    getCityByAreaCode(req, flag) {
      let that = this;
      getCityByAreaCode(req).then(res => {
        if (res && res.code === "200") {
          let obj = [];
          if (res.data.provincecode) {
            obj.push(res.data.provincecode);
          }
          if (res.data.areacode) {
            obj.push(res.data.areacode);
          }
          if (flag === 1) {
            that.userInfo.residence = obj;
          } else {
            that.userInfo.censusRegister = obj;
          }
          that.loadNext(obj);
        }
      });
    },
    getAllProvince(e) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getAllProvince()
        .then(res => {
          if (res && res.code === "200") {
            that.areaOptions = res.data.map((item, index) => {
              let obj = {};
              if (item.administrativeRegionLevel === 3) {
                obj = {
                  label: item.area,
                  value: item.areacode,
                  children: [],
                  index: index,
                  administrativeRegionLevel: item.administrativeRegionLevel
                };
              } else {
                obj = {
                  label: item.area,
                  value: item.areacode,
                  index: index,
                  administrativeRegionLevel: item.administrativeRegionLevel
                };
              }
              return obj;
            });
            if (e && e instanceof Function) {
              e();
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    handleItemChange(val) {
      if (val.length > 0) {
        this.loadNext(val);
      }
    },
    loadNext(val) {
      let that = this;
      let areaValues = that.areaOptions.map(item => {
        return item.value;
      });
      let index = areaValues.indexOf(val[0]);
      if (that.areaOptions[index].administrativeRegionLevel === 3) {
        that.getCityByProvince(val[0], index);
      }
    },
    getCityByProvince(val, index) {
      let that = this;
      getCityByProvince(val).then(res => {
        if (res && res.code === "200") {
          that.areaOptions[index].children = res.data.map((item, index) => {
            return {
              label: item.area,
              value: item.areacode,
              index: index
            };
          });
        }
      });
    },
    cancelResume() {
      this.initUser();
    },
    // 教育经历
    onGetResumeEducationList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeEducationList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeEduInfoList = res.data.map(item => {
                if (item.endTime) {
                  item.endTime = that.formatYear(item.endTime);
                }
                if (item.education) {
                  let obj = that.metaData.education.find(e => {
                    return (e.metaCode = item.education);
                  });
                  item.education = obj.metaName;
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindEduInfo(id, callback) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeEducation(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.eduForm = res.data;
              if (that.eduForm.uploadEducationAnnex) {
                that.eduForm.uploadEducationAnnex = JSON.parse(
                  that.eduForm.uploadEducationAnnex
                );
              }
              if (callback && callback instanceof Function) {
                callback();
              }
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onSaveEdu() {
      this.$refs["eduForm"].validate(valid => {
        if (valid) {
          this.uploadResumeEducationFile();
        } else {
          return false;
        }
      });
    },
    saveEdu() {
      let that = this;
      try {
        that.saveEduBth = true;
        let data = this._.cloneDeep(this.eduForm);
        data.uploadEducationAnnex = JSON.stringify(data.uploadEducationAnnex);
        data.endTime = that.formatDate(data.endTime);
        if (that.eduForm.id) {
          updateResumeEducation(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
                that.onFindEduInfo(that.eduForm.id);
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeEducationList();
              that.saveEduBth = false;
              this.eduEditVisible = false;
            });
        } else {
          addResumeEducation(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
                that.resetForm("eduForm");
                that.eduEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeEducationList();
              that.saveEduBth = false;
              this.eduEditVisible = false;
            });
        }
      } catch (e) {
        that.saveEduBth = false;
      }
    },
    onAddEdu() {
      this.eduForm.id = null;
      this.eduEditVisible = true;
    },
    onEditEdu(id) {
      this.eduEditVisible = true;
      this.onFindEduInfo(id);
    },
    onDelEdu(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeEducation(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeEducationList();
        });
    },
    uploadResumeEducationFile() {
      this.$refs["eduUploader"].submit();
    },
    showEduFiles(id) {
      let that = this;
      this.onFindEduInfo(id, () => {
        if (
          that.eduForm.uploadEducationAnnex &&
          that.eduForm.uploadEducationAnnex.length > 0
        ) {
          that.eduFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    },
    // 实习经历
    onGetResumeInternshipList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeInternshipList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeInternshipInfoList = res.data.map(item => {
                if (item.startTime) {
                  item.startTime = that.formatMonth(item.startTime);
                }
                if (item.endTime) {
                  item.endTime = that.formatMonth(item.endTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindInternshipInfo(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeInternship(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.internshipForm = res.data;
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onEditInternship(id) {
      let that = this;
      that.internshipEditVisible = true;
      this.onFindInternshipInfo(id);
    },
    onSaveInternship() {
      this.$refs["internshipForm"].validate(valid => {
        if (valid) {
          this.saveInternship();
        } else {
          return false;
        }
      });
    },
    saveInternship() {
      let that = this;
      try {
        that.saveInternshipBth = true;
        that.internshipForm.startTime = that.formatDate(
          that.internshipForm.startTime
        );
        that.internshipForm.endTime = that.formatDate(
          that.internshipForm.endTime
        );
        if (that.internshipForm.startTime > that.internshipForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveInternshipBth = false;
          return false;
        }
        if (that.internshipForm.id) {
          updateResumeInternship(that.userId, that.internshipForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeInternshipList();
              that.saveInternshipBth = false;
              that.internshipEditVisible = false;
            });
        } else {
          addResumeInternship(that.userId, that.internshipForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeInternshipList();
              that.saveInternshipBth = false;
              that.internshipEditVisible = false;
            });
        }
      } catch (e) {
        that.saveInternshipBth = false;
      }
    },
    onAddInternship() {
      this.internshipForm.id = null;
      this.internshipEditVisible = true;
    },
    onDelInternship(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeInternship(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeInternshipList();
        });
    },
    // 项目经历
    onGetResumeProjectList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeProjectList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeProjectInfoList = res.data.map(item => {
                if (item.startTime) {
                  item.startTime = that.formatMonth(item.startTime);
                }
                if (item.endTime) {
                  item.endTime = that.formatMonth(item.endTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindProjectInfo(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeProject(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.projectForm = res.data;
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onEditProject(id) {
      this.projectEditVisible = true;
      this.onFindProjectInfo(id);
    },
    onSaveProject() {
      this.$refs["projectForm"].validate(valid => {
        if (valid) {
          this.saveProject();
        } else {
          return false;
        }
      });
    },
    saveProject() {
      let that = this;
      try {
        that.saveProjectBth = true;
        that.projectForm.startTime = that.formatDate(
          that.projectForm.startTime
        );
        that.projectForm.endTime = that.formatDate(that.projectForm.endTime);
        if (that.projectForm.startTime > that.projectForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveProjectBth = false;
          return false;
        }
        if (that.projectForm.id) {
          updateResumeProject(that.userId, that.projectForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeProjectList();
              that.saveProjectBth = false;
              this.projectEditVisible = false;
            });
        } else {
          addResumeProject(that.userId, that.projectForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeProjectList();
              that.saveProjectBth = false;
              this.projectEditVisible = false;
            });
        }
      } catch (e) {
        that.saveProjectBth = false;
      }
    },
    onAddProject() {
      this.projectForm.id = null;
      this.projectEditVisible = true;
    },
    onDelProject(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeProject(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeProjectList();
        });
    },
    // 培训经历
    onGetResumeTrainingList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeTrainingList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeTrainingInfoList = res.data.map(item => {
                if (item.startTime) {
                  item.startTime = that.formatMonth(item.startTime);
                }
                if (item.endTime) {
                  item.endTime = that.formatMonth(item.endTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindTrainingInfo(id, callback) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeTraining(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.trainingForm = res.data;
              if (that.trainingForm.uploadCertificate) {
                that.trainingForm.uploadCertificate = JSON.parse(
                  that.trainingForm.uploadCertificate
                );
              }
              if (callback && callback instanceof Function) {
                callback();
              }
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onEditTraining(id) {
      this.trainingEditVisible = true;
      this.onFindTrainingInfo(id);
    },
    onSaveTraining() {
      this.$refs["trainingForm"].validate(valid => {
        if (valid) {
          this.uploadResumeTrainingFile();
        } else {
          return false;
        }
      });
    },
    saveTraining() {
      let that = this;
      try {
        that.saveTrainingBth = true;
        let data = this._.cloneDeep(this.trainingForm);
        data.startTime = that.formatDate(data.startTime);
        data.endTime = that.formatDate(data.endTime);
        if (data.startTime > data.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveTrainingBth = false;
          return false;
        }
        data.uploadCertificate = JSON.stringify(data.uploadCertificate);
        if (that.trainingForm.id) {
          updateResumeTraining(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeTrainingList();
              that.saveTrainingBth = false;
              this.trainingEditVisible = false;
            });
        } else {
          addResumeTraining(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
                that.resetForm("trainingForm");
                that.trainingEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeTrainingList();
              that.saveTrainingBth = false;
              this.trainingEditVisible = false;
            });
        }
      } catch (e) {
        that.saveTrainingBth = false;
      }
    },
    onAddTraining() {
      this.trainingForm.id = null;
      this.trainingEditVisible = true;
    },
    onDelTraining(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeTraining(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeTrainingList();
        });
    },
    uploadResumeTrainingFile() {
      this.$refs["trainingUploader"].submit();
    },
    showTrainingFiles(id) {
      let that = this;
      this.onFindTrainingInfo(id, () => {
        if (
          that.trainingForm.uploadCertificate &&
          that.trainingForm.uploadCertificate.length > 0
        ) {
          that.trainingFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    },
    // 工作经历
    onGetResumeWorkList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeWorkList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeWorkInfoList = res.data.map(item => {
                if (item.startTime) {
                  item.startTime = that.formatMonth(item.startTime);
                }
                if (item.endTime) {
                  item.endTime = that.formatMonth(item.endTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindWorkInfo(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeWork(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.workForm = res.data;
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onEditWork(id) {
      let that = this;
      that.workEditVisible = true;
      this.onFindWorkInfo(id);
    },
    onSaveWork() {
      this.$refs["workForm"].validate(valid => {
        if (valid) {
          this.saveWork();
        } else {
          return false;
        }
      });
    },
    saveWork() {
      let that = this;
      try {
        that.saveWorkBth = true;
        that.workForm.startTime = that.formatDate(that.workForm.startTime);
        that.workForm.endTime = that.formatDate(that.workForm.endTime);
        if (that.workForm.startTime > that.workForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveWorkBth = false;
          return false;
        }
        if (that.workForm.id) {
          updateResumeWork(that.userId, that.workForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeWorkList();
              that.saveWorkBth = false;
              that.workEditVisible = false;
            });
        } else {
          addResumeWork(that.userId, that.workForm)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeWorkList();
              that.saveWorkBth = false;
              that.workEditVisible = false;
            });
        }
      } catch (e) {
        that.saveWorkBth = false;
      }
    },
    onAddWork() {
      this.workForm.id = null;
      this.workEditVisible = true;
    },
    onDelWork(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeWork(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeWorkList();
        });
    },
    // 所获荣誉
    onGetResumeCertificateList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeCertificateList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeCertificateInfoList = res.data.map(item => {
                if (item.winningTime) {
                  item.winningTime = that.formatMonth(item.winningTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onGetResumeHonourList() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      getResumeHonourList(this.userId)
        .then(res => {
          if (res && res.code === "200") {
            that.serviceCount++;
            if (res.data) {
              that.resumeHonourInfoList = res.data.map(item => {
                if (item.winningTime) {
                  item.winningTime = that.formatMonth(item.winningTime);
                }
                return item;
              });
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindCertificateInfo(id, callback) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeCertificate(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.certificateForm = res.data;
              if (that.certificateForm.uploadCertificate) {
                that.certificateForm.uploadCertificate = JSON.parse(
                  that.certificateForm.uploadCertificate
                );
              }
              if (callback && callback instanceof Function) {
                callback();
              }
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onFindHonourInfo(id, callback) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findResumeHonour(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.honourForm = res.data;
              if (that.honourForm.uploadCertificate) {
                that.honourForm.uploadCertificate = JSON.parse(
                  that.honourForm.uploadCertificate
                );
              }
              if (callback && callback instanceof Function) {
                callback();
              }
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onEditCertificate(id) {
      this.certificateEditVisible = true;
      this.onFindCertificateInfo(id);
    },
    onEditHonour(id) {
      this.honourEditVisible = true;
      this.onFindHonourInfo(id);
    },
    onSaveCertificate() {
      this.$refs["certificateForm"].validate(valid => {
        if (valid) {
          this.uploadResumeCertificateFile();
        } else {
          return false;
        }
      });
    },
    onSaveHonour() {
      this.$refs["honourForm"].validate(valid => {
        if (valid) {
          this.uploadResumeHonourFile();
        } else {
          return false;
        }
      });
    },
    saveCertificate() {
      let that = this;
      try {
        that.saveCertificateBth = true;
        let data = this._.cloneDeep(this.certificateForm);
        data.winningTime = that.formatDate(data.winningTime);
        data.uploadCertificate = JSON.stringify(data.uploadCertificate);
        if (that.certificateForm.id) {
          updateResumeCertificate(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeCertificateList();
              that.saveCertificateBth = false;
              this.certificateEditVisible = false;
            });
        } else {
          addResumeCertificate(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
                that.resetForm("certificateForm");
                that.certificateEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeCertificateList();
              that.saveCertificateBth = false;
              this.certificateEditVisible = false;
            });
        }
      } catch (e) {
        that.saveCertificateBth = false;
      }
    },
    saveHonour() {
      let that = this;
      try {
        that.saveHonourBth = true;
        let data = this._.cloneDeep(this.honourForm);
        data.winningTime = that.formatDate(data.winningTime);
        data.uploadCertificate = JSON.stringify(data.uploadCertificate);
        if (that.honourForm.id) {
          updateResumeHonour(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeHonourList();
              that.saveHonourBth = false;
              this.honourEditVisible = false;
            });
        } else {
          addResumeHonour(that.userId, data)
            .then(res => {
              if (res.code === "200") {
                that.$message.success("保存成功");
                that.resetForm("honourForm");
                that.honourEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeHonourList();
              that.saveHonourBth = false;
              this.honourEditVisible = false;
            });
        }
      } catch (e) {
        that.saveHonourBth = false;
      }
    },
    onAddCertificate() {
      this.certificateForm.id = null;
      this.certificateEditVisible = true;
    },
    onAddHonour() {
      this.honourForm.id = null;
      this.honourEditVisible = true;
    },
    onDelCertificate(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeCertificate(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeCertificateList();
        });
    },
    onDelHonour(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeHonour(id)
        .then(res => {
          if (res.code === "200") {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeHonourList();
        });
    },
    uploadResumeCertificateFile() {
      this.$refs["certificateUploader"].submit();
    },
    uploadResumeHonourFile() {
      this.$refs["honourUploader"].submit();
    },
    showCertificateFiles(id) {
      let that = this;
      this.onFindCertificateInfo(id, () => {
        if (
          that.certificateForm.uploadCertificate &&
          that.certificateForm.uploadCertificate.length > 0
        ) {
          that.certificateFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    },
    showHonourFiles(id) {
      let that = this;
      that.onFindHonourInfo(id, () => {
        if (
          that.honourForm.uploadCertificate &&
          that.honourForm.uploadCertificate.length > 0
        ) {
          that.honourFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-user {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
  .el-textarea {
    width: 500px;
  }
  .el-input,
  .el-select,
  .el-date-editor,
  .el-date-editor,
  .el-cascader {
    width: 250px;
  }
  .el-dialog__wrapper {
    .el-input,
    .el-select,
    .el-cascader {
      width: 500px !important;
    }
    .el-date-editor {
      width: 250px !important;
    }
  }
  .bottom_bth {
    background-color: #e4e7ed;
    padding: 10px 0;
    position: fixed;
    bottom: 0px;
    left: 0px;
    text-align: center;
  }
}
</style>
